export const getInitialState = ({ alert }) => ({
  active: alert.active,
  context: alert.context,
  currentAlert: alert.message,
  currentAlertEditing: false,
  defaultAlert: alert.defaultMessage,
  defaultAlertEditing: false,
});

export const SELECTORS = {
  getActive: state => state.active,
  getContext: state => state.context,
  getCurrentAlert: state => state.currentAlert,
  getCurrentAlertEditing: state => state.currentAlertEditing,
  getDefaultAlert: state => state.defaultAlert,
  getDefaultAlertEditing: state => state.defaultAlertEditing,
};

export const TYPES = {
  activeToggle: 'alert/active/toggle',
  contextUpdate: 'alert/context/update',
  currentAlertApplyDefault: 'alert/current/edit/default',
  currentAlertCancelEdit: 'alert/current/edit/cancel',
  currentAlertEdit: 'alert/current/edit',
  currentAlertSave: 'alert/current/save',
  currentAlertUpdate: 'alert/current/update',
  defaultAlertCancelEdit: 'alert/default/edit/cancel',
  defaultAlertEdit: 'alert/default/edit',
  defaultAlertSave: 'alert/default/save',
  defaultAlertUpdate: 'alert/default/update',
};

const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.activeToggle:
      return {
        ...state,
        active: !state.active,
      };
    case TYPES.contextUpdate:
      return {
        ...state,
        context: action.value,
      };
    case TYPES.currentAlertApplyDefault:
      return {
        ...state,
        currentAlert: action.value,
      };
    case TYPES.currentAlertCancelEdit:
      return {
        ...state,
        currentAlert: action.value,
        currentAlertEditing: false,
      };
    case TYPES.currentAlertEdit:
      return {
        ...state,
        currentAlertEditing: true,
      };
    case TYPES.currentAlertSave:
      return {
        ...state,
        currentAlertEditing: false,
      };
    case TYPES.currentAlertUpdate:
      return {
        ...state,
        currentAlert: action.value,
      };
    case TYPES.defaultAlertCancelEdit:
      return {
        ...state,
        defaultAlert: action.value,
        defaultAlertEditing: false,
      };
    case TYPES.defaultAlertEdit:
      return {
        ...state,
        defaultAlertEditing: true,
      };
    case TYPES.defaultAlertSave:
      return {
        ...state,
        defaultAlertEditing: false,
      };
    case TYPES.defaultAlertUpdate:
      return {
        ...state,
        defaultAlert: action.value,
      };
    default:
      return state;
  }
};

export default reducer;
